module.exports = __webpack_public_path__ + "static/ogp-ca87e439f1f81ace946eececf4532175.png";